import PagosRequestInputTransformer from './requests/PagosRequestInputTransformer';
import NominaRequestInputTransformer from './requests/NominaRequestInputTransformer';
import ComprobanteBaseRequestInputTransformer from './requests/ComprobanteBaseRequestInputTransformer';
import ComplementoImpuestosLocalesInputTransformer from './requests/ComplementoImpuestosLocalesInputTransformer';
import ComplementoCartaPorteRequestInputTransformer from './requests/ComplementoCartaPorteRequestInputTransformer';
import ComplementoDonatariasRequestInputTransformer from './requests/ComplementoDonatariasRequestInputTransformer';
import ComplementoVehiculoUsadoRequestInputTransformer from './requests/ComplementoVehiculoUsadoRequestInputTransformer';
import ComplementoComercioExteriorRequestInputTransformer from './requests/ComplementoComercioExteriorRequestInputTransformer';

class ComprobanteRequestInputTransformer {
  complementos = {};

  constructor() {
    this.boot();
  }

  boot() {
    this.register(new PagosRequestInputTransformer());
    this.register(new NominaRequestInputTransformer());
    this.register(new ComprobanteBaseRequestInputTransformer());
    this.register(new ComplementoImpuestosLocalesInputTransformer());
    this.register(new ComplementoCartaPorteRequestInputTransformer());
    this.register(new ComplementoDonatariasRequestInputTransformer());
    this.register(new ComplementoVehiculoUsadoRequestInputTransformer());
    this.register(new ComplementoComercioExteriorRequestInputTransformer());
  }

  register(transformer) {
    this.complementos[transformer.getName()] = transformer;

    return this;
  }

  make(input) {
    input = JSON.parse(JSON.stringify(input));

    for (const transformer of Object.values(this.complementos)) {
      input = transformer.make(input);
    }

    return input;
  }

  _prepare(input) {}
}

export default ComprobanteRequestInputTransformer;
